import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса своей номенклатуры (`Resource.Own`, RP-OWN1) через шлюз: всё — под ресурсом из адреса окна. Литерал `/api/` законен
 * только здесь. Права: чтение — `catalog.read` / `prices.read`, запись — `catalog.write` / `prices.write` на этом ресурсе.
 */
const base = (resourceId: string) => `/api/own/v1/resources/${ridSegment(resourceId)}`
const id = (value: string) => encodeURIComponent(value)

export const OWN_NOMENCLATURE_URLS = {
  /** `GET ?cursor=&limit=&sku=&barcode=&groupId=&archived=`; `POST` — новый товар. */
  products: (resourceId: string) => `${base(resourceId)}/catalog/products`,
  /** `GET ?on=` — карточка с ценами на дату; `PUT` — правка с версией. */
  product: (resourceId: string, productId: string) => `${base(resourceId)}/catalog/products/${id(productId)}`,
  /** `GET` — расширение карточки (полное наименование, группа, маркировка) из базы службы (ADR-21, RP-FB71). */
  productExtension: (resourceId: string, productId: string) => `${base(resourceId)}/catalog/products/${id(productId)}/extension`,
  archive: (resourceId: string, productId: string) => `${base(resourceId)}/catalog/products/${id(productId)}/archive`,
  restore: (resourceId: string, productId: string) => `${base(resourceId)}/catalog/products/${id(productId)}/restore`,
  groups: (resourceId: string) => `${base(resourceId)}/catalog/groups`,
  group: (resourceId: string, groupId: string) => `${base(resourceId)}/catalog/groups/${id(groupId)}`,
  priceTypes: (resourceId: string) => `${base(resourceId)}/prices/types`,
  priceType: (resourceId: string, typeId: string) => `${base(resourceId)}/prices/types/${id(typeId)}`,
  /** `GET ?productId=&priceTypeId=&on=` (без даты — вся история); `POST` — новая цена; `DELETE ?productId=&priceTypeId=&validFrom=`. */
  prices: (resourceId: string) => `${base(resourceId)}/prices`,
} as const
